// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n33P3oN4W4qcbqE968SI{align-items:center;height:56px;padding:14px 14px 12px 16px}.ncnjPMuYFAbI_uNuWe1N{height:100%}.vaiUJSwYZjgk6oR0k2DY{color:var(--content-primary-primary)}.vaiUJSwYZjgk6oR0k2DY span{color:var(--content-primary-disabled)}.NsppYPybf7YvTaO5CxQp{height:28px}.AzV86J0R4FYzMDzDhqAZ{height:100%;color:var(--content-primary-primary);justify-content:space-between;align-items:center;display:flex}.AzV86J0R4FYzMDzDhqAZ>span:last-child{color:var(--content-primary-disabled)}.OUPOclJ5HLgZenm3_On0,.OI_DVACHGcSVs3M894O8{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownPlaceholder": `n33P3oN4W4qcbqE968SI`,
	"dropdownPlaceholderInner": `ncnjPMuYFAbI_uNuWe1N`,
	"dropdownItem": `vaiUJSwYZjgk6oR0k2DY`,
	"dropdownLabel": `NsppYPybf7YvTaO5CxQp`,
	"dropdownActive": `AzV86J0R4FYzMDzDhqAZ`,
	"additionalCreditAmount": `OUPOclJ5HLgZenm3_On0`,
	"priceLabel": `OI_DVACHGcSVs3M894O8`
};
export default ___CSS_LOADER_EXPORT___;
